var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui basic active tab" }, [
    _c("div", { staticClass: "ui" }, [
      _c("h1", { staticClass: "header" }, [
        _vm._v("\n\t\t\t" + _vm._s(_vm.$t("pages.bookings.header")) + "\n\t\t")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ui divider" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui two column grid" },
      [
        _c("available-bookings", {
          staticClass:
            "sixteen wide mobile six wide tablet six wide computer column"
        }),
        _vm._v(" "),
        _c("reserved-bookings", {
          staticClass:
            "sixteen wide mobile ten wide tablet ten wide computer column"
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e53416d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e53416d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchant/Bookings.vue
// module id = rEjs
// module chunks = 1